type LogMethod = (...args: unknown[]) => void;

interface IPCLogger {
  log: LogMethod;
  warn: LogMethod;
  error: LogMethod;
}

let logger: IPCLogger = {
  log: console.log,
  warn: console.warn,
  error: console.error,
};

export const setIPCLogger = (customLogger: Partial<IPCLogger>) => {
  logger = {
    ...logger,
    ...customLogger,
  };
};

export const ipcLog = {
  log: (...args: unknown[]) => logger.log(...args),
  warn: (...args: unknown[]) => logger.warn(...args),
  error: (...args: unknown[]) => logger.error(...args),
};
